import { render } from "./Ending.vue?vue&type=template&id=693b323b&scoped=true"
const script = {}

import "./Ending.vue?vue&type=style&index=0&id=693b323b&scoped=true&lang=scss"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693b323b"]])

export default __exports__